import React from "react"
import collect from "collect.js"
import PropTypes from "prop-types"
import SelectorHR from "components/Select"
import { Button } from "antd"

const CompanyUserAccessSelect = (props) => {
  const countValues = () => {
    const collectValues = collect(props.dataSource)
    return collectValues.count() === 0 ? "" : `(${collectValues.count()})`
  }

  return (
    <div
      className="ManduUserDrawerComponent-FormNew-section"
      style={{ maxWidth: "100%" }}>
      <div>
        <h4>
          Permisos{" "}
          <span className="color-gray-low" style={{ fontWeight: 400 }}>
            {countValues()}
          </span>
        </h4>
      </div>
      <div style={{ marginBottom: "9px" }}>
        Selecciona las empresas a las que podrá acceder el usuario:
      </div>
      <div style={{ display: "flex" }}>
        <SelectorHR
          placeholder="Seleccionar empresa"
          options={props.options}
          labelKey="id_company"
          disabled={props.companiesAccessLoading}
          label="name"
          allowClear
          value={props.itemSelectCompanyAccess}
          onChange={(item) => props.activeButtonSelectedItemAccess(item)}
        />
        <Button
          disabled={props.disableButtonAddCompanyAccess}
          onClick={() => props.selectItem()}
          type="primary"
          style={{ marginLeft: 10 }}>
          Asignar
        </Button>
      </div>
    </div>
  )
}

CompanyUserAccessSelect.propTypes = {
  selectItem: PropTypes.func.isRequired,
  options: PropTypes.array,
  companiesAccessLoading: PropTypes.bool,
  dataSource: PropTypes.array,
}

export default CompanyUserAccessSelect
